import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const thousandFormat = Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0
})

const authorKarmaResolver: FieldResolver = (metadata: Metadata) =>
  ({
    authorKarma:
      metadata.getAuthorKarma() !== undefined
        ? thousandFormat.format(metadata.getAuthorKarma()!)
        : undefined
  } as StreamData)

export default authorKarmaResolver
